import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const BrunswickWestPage = () => (
  <LocationTemplate suburbName="Brunswick West" suburbSlug="brunswick-west" />
);

export default BrunswickWestPage;
